import { styled } from '@mui/styles';
import { IconButtonWithTooltip } from 'components/common/IconButton/IconButtonWithTooltip';

export const StyledIconButton = styled(IconButtonWithTooltip)(() => ({
  margin: 0,
  padding: 0,
}));
